/**
 * IDs clients utilisés côté frontend.
 * Dans PRIsME_BZ, le client BZ (interne) est 2.
 */

export const BZ_CLIENT_ID = 2;

// Par défaut, on travaille sur BZ (Comité PRIsME interne)
export const DEFAULT_CLIENT_ID = BZ_CLIENT_ID;

